import { NsContent } from '@britishgasenergy/react-nucleus';

import { NsBackCta } from 'components/common/ns-back-cta/NsBackCta';
import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { NsPrimaryCta } from 'components/common/ns-primary-cta/NsPrimaryCta';
import { NsCaveat } from 'components/common/ns-caveat/NsCaveat';

import { EvTariffInformationSteps } from './components/EvTariffInformationSteps';
import { EvTariffRateInfo } from './components/EvTariffRateInfo';

import { useNavigation } from 'hooks/useNavigation';

export const evTariffCaveatTestId = 'evTariffCaveat';
export const evTariffInformationTestId = 'evTariffInformation';

export const EvTariffInformation = () => {
  const { next, eventTypes } = useNavigation();
  const handleNext = () => {
    next({ eventType: eventTypes.NEXT });
  };

  return (
    <div data-testid={evTariffInformationTestId}>
      <NsPanel>
        <NsBackCta />
        <EvTariffRateInfo />
      </NsPanel>
      <NsPanel decoration="grey-light">
        <EvTariffInformationSteps />
      </NsPanel>
      <NsPanel>
        <NsContent>
          <NsPrimaryCta onClick={handleNext}>Choose a tariff</NsPrimaryCta>
        </NsContent>
      </NsPanel>
      <NsCaveat testId={evTariffCaveatTestId} heading="Legal Information" />
    </div>
  );
};

export default EvTariffInformation;
